// Modal1.tsx
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useState } from 'react';
import { useAuth } from '../../../auth';
import { useAppSelector } from '../../../../../redux/hooks';
import axios from 'axios';
import { useEffect } from 'react';
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../../accounts/troubleshoot/request/request';
import Swal from 'sweetalert2';
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo';
const API_URL = process.env.REACT_APP_API_URL


interface Modal1Props {
  showModal: boolean;
  handleClose: () => void;
  setDatos: any

}

type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}
type vecino = {
  ip: string,
  desc: string
}

type ID = undefined | null | number

const Modal1: React.FC<Modal1Props> = ({ showModal, handleClose, setDatos }) => {
  const [ID, setID] = useState<ID>(undefined)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const { currentUser } = useAuth()
  const [prefix, setprefix] = useState<any>()
  const [greater, setgreater] = useState('')
  const [less, setless] = useState('')
  const [action, setaction] = useState<any>()
  const [vrfselect, setselectvrf] = useState<any>()
  const [listvrf, setlistvrff] = useState<vrf[]>([])
  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])
  const [Busqueda, setBusqueda] = useState("")
  const [vecino, setvecino] = useState<any>()
  const [listvecino, setlistvecino] = useState<vecino[]>([])
  const [configApplied, setConfigApplied] = useState(false);




  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }

  const vecinoseleccionado = (e: any) => {
    setvecino(e.target.value)
  }


  const actionselect = (e: any) => {
    setaction(e.target.value)
  }
  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)

  }


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (FlagReg === true) {
          if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
          else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [FlagReg, nameregion]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(-1, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(-1, tenant, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          if (type === "ctx") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf/add', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Busqueda !== '' && vrfselect !== undefined && vrfselect !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[vrfselect]
          if (type === "ctx") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [vrfselect])
  /*********************************************SE REALIZA POST PARA AGREGAR PREFIX LIST*********************** */
  const [del, setdel] = useState(false)
  const [swalInput, setSwalInput] = useState('');

  useEffect(() => {
    if (configApplied) {
      handleClose(); // Cierra el modal automáticamente
    }
  }, [configApplied]);

  const ADDSegment = async () => {
    if (Id !== 0 && Id !== -1 && Busqueda !== '' && vecino !== '' && prefix !== '' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {
        let type
        for (const x of Instancia) {
          if (Number(Busqueda) === x.id) {
            type = x.type
          }
        }
        const vrf = listvrf[vrfselect]

        const body = {
          type: type,
          vrf: vrf,
          neighbor: vecino,
          prefix: {
            ip: prefix,
            ge: greater,
            le: less,
            policy: action
          }
        }
        // Muestra el SweetAlert antes de realizar la primera solicitud
        /*Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Tu Segmento está siendo agregado, este proceso puede tardar unos segundos, por favor espera',
          showConfirmButton: false,
          allowOutsideClick: false // Evitar que el usuario cierre el alert haciendo clic fuera de él
        });*/

        //Se pregunta si se quiere aplicar la config 
        Swal.fire({
          width: '40%',
          position: 'center',
          icon: 'warning',
          title: "Are you sure you want to apply this configuration?",
          html: ` <p>
                <strong>¡Attention!</strong> You are about to apply new configuration settings. Please verify that the following IP addresses belong to your network:</p>
                <strong style="color: red">This process may take a few seconds, please wait.</strong>
                <br/>
                <br/>
                <pre>Ip:${prefix}</pre>
                <pre>Greater Than:${greater}</pre>
                <pre>Less Than:${less}</pre>
                <pre>Policy:${action}</pre>
                `,
          input: 'text',
          inputPlaceholder: 'Enter "confirm" to continue...',
          inputValue: swalInput,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Add!',
          preConfirm: (value) => {
            if (!value.toLowerCase().includes('confirm')) {
              Swal.showValidationMessage('The input must contain the word "confirm"');
            } else {
              setSwalInput(value);
            }
          },
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              if (tenant === 0) {
                axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix', body).then(res => {
                  setConfigApplied(true);
                  /********************************************************************** */
                  if (res.data.data && res.data.data.length !== 0) {
                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {
                      Swal.fire({
                        icon: 'warning',
                        title: 'An error occurred',
                        html: `<p>Some segments could not be added</p>
                            <pre>${res.data.error.map((data: any) => `IP${data.ip} 
                            Greater than:${data.ge || ''}
                            Less than: ${data.le || ''}
                            Policy:${data.policy || ''}`).join('\n')}</pre>`
                      });
                      setDatos(res.data.data);
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito
                      Swal.fire(
                        'Added!',
                        'Your BGP Segments have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data.data);
                    }
                  } else if (res.data.error && res.data.error.length !== 0) {
                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'An error occurred',
                      html: `<p>The segment could not be added</p>
                          <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `IP: ${data.ip}<br/>`).join('')}</pre>
                          <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Greater Than: ${data.ge}<br/>`).join('')}</pre>
                          <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Less Than: ${data.le}<br/>`).join('')}</pre>
                          <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Policy: ${data.policy}<br/>`).join('')}</pre>
                          `
                    });
                  }
                  /************************************************************************* */
                });
              }
              else {
                axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix?tenantId=' + tenant, body).then(res => {
                  setConfigApplied(true);
                  /********************************************************************** */
                  if (res.data.data && res.data.data.length !== 0) {
                    // Si hay datos, pero también hay errores, mostrar un mensaje combinado
                    if (res.data.error && res.data.error.length !== 0) {
                      Swal.fire({
                        icon: 'warning',
                        title: 'An error occurred',
                        html: `<p>The segment could not be added</p>
                                <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `IP: ${data.ip}<br/>`).join('')}</pre>
                                <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Greater Than: ${data.ge}<br/>`).join('')}</pre>
                                <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Less Than: ${data.le}<br/>`).join('')}</pre>
                                <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Policy: ${data.policy}<br/>`).join('')}</pre>

                                `
                      });
                      setDatos(res.data.data);
                      setdel(false);
                    } else {
                      // Solo hay datos, mostrar el mensaje de éxito
                      Swal.fire(
                        'Added!',
                        'Your BGP Segments have been Added.',
                        'success'
                      );
                      setdel(false);
                      setDatos(res.data.data);
                    }
                  } else if (res.data.error && res.data.error.length !== 0) {
                    // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
                    Swal.fire({
                      icon: 'warning',
                      title: 'An error occurred',
                      html: `<p>The segment could not be added</p>
                              <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `IP: ${data.ip}<br/>`).join('')}</pre>
                              <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Greater Than: ${data.ge}<br/>`).join('')}</pre>
                              <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Less Than: ${data.le}<br/>`).join('')}</pre>
                              <pre style="text-align: center; margin: auto;">${res.data.error.map((data: any) => `Policy: ${data.policy}<br/>`).join('')}</pre>

                              `
                    });
                  }
                  /************************************************************************* */
                });
              }
            } else {
              Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
            }
          });
        // Realiza la primera solicitud axios 
      }
      catch (error: any) {
        console.log(error)

      }
    }
  }



  const ADDSegmentGlobal = async () => {
    if (Id === -1 && Busqueda !== '' && vecino !== '' && prefix !== '' && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {
        let type
        for (const x of Instancia) {
          if (Number(Busqueda) === x.id) {
            type = x.type
          }
        }
        const vrf = listvrf[vrfselect]

        const body = {
          type: type,
          vrf: vrf,
          neighbor: vecino,
          prefix: {
            ip: prefix,
            ge: greater,
            le: less,
            policy: action
          }
        }
        // Muestra el SweetAlert antes de realizar la primera solicitud
        /*Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Tu Segmento está siendo agregado, este proceso puede tardar unos segundos, por favor espera',
          showConfirmButton: false,
          allowOutsideClick: false // Evitar que el usuario cierre el alert haciendo clic fuera de él
        });*/

        //Se pregunta si se quiere aplicar la config 
        Swal.fire({
          width: '40%',
          position: 'center',
          icon: 'warning',
          title: "Are you sure you want to apply this configuration?",
          text: "If you send incorrect data, there's a risk of losing connectivity.",
          html: ` <p>
                  <strong>¡Attention!</strong> You are about to apply new configuration settings. Please verify that the following IP addresses belong to your network:</p>
                  <pre>Ip:${prefix}</pre>
                  <pre>Greater Than:${greater}</pre>
                  <pre>Less Than:${less}</pre>
                  <pre>Policy:${action}</pre>
                  <p class= fs-7><strong>If you send incorrect data, there's a risk of losing connectivity.</strong></p>
                  `,
          input: 'text',
          inputPlaceholder: 'Enter "confirm" to continue...',
          inputValue: swalInput,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Add!',
          preConfirm: (value) => {
            if (!value.toLowerCase().includes('confirm')) {
              Swal.showValidationMessage('The input must contain the word "confirm"');
            } else {
              setSwalInput(value);
            }
          },
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              if (tenant === 0) {
                axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix', body).then(res => {
                  setConfigApplied(true);
                  Swal.fire(
                    'Added!',
                    'Your BGP Segment has been Added.',
                    'success'
                  )
                  setdel(false)
                  setDatos(res.data)
                });
              }
              else {
                axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix?tenantId=' + tenant, body).then(res => {
                  setConfigApplied(true);
                  Swal.fire(
                    'Added',
                    'Your BGP Segment has been Added.',
                    'success'
                  )
                  setdel(false)
                  setDatos(res.data)


                });
              }
            } else {
              Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
            }
          });

        // Realiza la primera solicitud axios
        // Cierra el SweetAlert después de completar las solicitudes
        //Swal.close();
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }

  useEffect(() => {
    return () => {
      setConfigApplied(false); // Restablece configApplied cuando el componente se desmonta
    };
  }, [configApplied]);



  useEffect(() => {
    if (Busqueda) {
      setselectvrf('')
      setlistvecino([])
      setvecino('')
      setgreater('')
      setless('')
      setaction('')
    }
  }, [Busqueda])

  useEffect(() => {
    if (vrfselect) {
      setvecino('')
      setgreater('')
      setless('')
      setaction('')
    }
  }, [vrfselect])


  return (
    <>
      <div>
        <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex={-1} aria-labelledby="exampleModalLabel1" aria-hidden={!showModal}>
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel1">Modal Title</h5>
                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/* Contenido específico para Modal 1 */}
                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add BGP SegMent</h1>
                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                  <div className='text-info'>
                    Use this section to  <strong>Add</strong> BGP Segments.
                  </div>
                </div>
                {/* Campos solicitud */}
                <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Instance</label>
                <select className="form-select text-center  border-gray-300 f-parrafo " aria-label="Select example"
                  required
                  onChange={cambiarstate} value={Busqueda}>
                  {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                  <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                  {Id !== 0 && Id !== -1 && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                  {Id === -1 && Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                </select>

                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                  <div>
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >VRF</label>
                    <select className="form-select text-center w-200px border-gray-300 f-parrafo" aria-label="Select example"
                      onChange={vrfseleccionada} value={vrfselect}>
                      {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                      {Busqueda !== '' && Id !== 0 && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                        <>
                          {!vrf.vrf && <option key={i} value={i}>Main</option>}
                          {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                        </>
                      )
                      }

                      {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                        <>
                          {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                          {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                        </>
                      )
                      }
                    </select>
                  </div>


                  <div>
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Neighbor</label>
                    <select className="form-select text-center w-200px border-gray-300 f-parrafo" aria-label="Select example"
                      onChange={vecinoseleccionado} value={vecino}>

                      {listvecino?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Neighbor</option> : <option hidden>Select an Neighbor </option>}

                      {Busqueda !== '' && Id !== 0 && Id !== -1 && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i: any) =>
                        <>
                          {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}
                        </>
                      )
                      }

                      {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i) =>
                        <>
                          {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}

                        </>
                      )
                      }
                    </select>
                  </div>
                </div>

                <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Prefix</label>
                <input
                  required

                  type="text"
                  className="form-control form-control-solid border-gray-300 f-parrafo "
                  placeholder="x.x.x.x/xx"
                  id='Resumen'
                  onChange={(e: any) => setprefix(e.target.value)}
                  maxLength={150}

                />

                <br />
                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                  <div className="d-flex flex-column flex-row-auto">
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Greater Than</label>

                    <input
                      required

                      type="number"
                      className="form-control form-control-solid border-gray-300 f-parrafo "
                      id='Resumen'
                      onChange={(e: any) => setgreater(e.target.value)}
                      min="0" max="32"
                      value={greater}
                    />
                    {/*(greater>32)&&<label className='text-danger'>Please Select a valid BGP Segment</label>*/}
                  </div>
                  <div className='w-30px'></div>

                  <div className="d-flex flex-column flex-row-auto">
                    <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Less Than</label>
                    <input
                      required

                      type="number"
                      className="form-control form-control-solid border-gray-300 "
                      id='Resumen'
                      onChange={(e: any) => setless(e.target.value)}
                      min="0" max="32"
                      value={less}
                    />
                    {/*(less>32)&&<label className='text-danger'>Please Select a valid BGP Segment</label>*/}

                  </div>
                </div>
                <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Actions</label>
                <select className="form-select text-center border-gray-300 f-parrafo" aria-label="Select example"
                  onChange={actionselect} value={action}>
                  <option key={'x'} className='text-info' hidden>Select Action</option>
                  <option key={'1'} className='text-info ' value={'permit'}>Permit</option>
                  <option key={'2'} className='text-info' value={'deny'}>Deny</option>
                </select>
                <br />
                {currentUser?.is_demo !== true && <div className="d-flex justify-content-center">
                  <div className='row'>
                    <div className='flex col'>
                      {currentUser?.ListPermiso?.includes('Ctx.BGP.Add') && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && <button onClick={ADDSegment} type='submit' id='kt_sign_in_submit'
                      >{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}</button>}

                      {currentUser?.ListPermiso?.includes('Ctx.BGP.Add') && Id === -1 && Type === 'CloudGlobal' && <button onClick={ADDSegmentGlobal} type='submit' id='kt_sign_in_submit'
                      >{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}</button>}


                      <button
                        className='btn-cancel btn border border-pink text-pink f-parrafo'
                        style={{ marginLeft: "10px", width: '200px' }}
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <br />

                </div>}

                {currentUser?.is_demo === true && <div className="d-flex justify-content-center">
                  <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'
                  >{del ? 'Adding...' : 'Add'}</button>

                </div>}


              </div>
              {/*<div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
                    </div>*/}
            </div>
          </div>
        </div>
        {showModal && <div className='modal-backdrop fade show'></div>}
        {ID !== undefined && <DemoModal setID={setID} id={ID} />}
      </div>
    </>
  );
};

export default Modal1;